module.exports = require("/opt/build/repo/src/components/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 300
// module chunks = 231608221292675